import React from "react";
import MediaQuery from "react-responsive";

import { menuStyles } from "@common/styles";
import Menu from "./menu";
import { IChildContainerProps } from "./home";

const large: React.StatelessComponent<IChildContainerProps> = ({
  children
}) => (
  <MediaQuery minDeviceWidth={1024}>
    <div
      style={menuStyles.flexColumnWrapper as any}
      className="flexColumnWrapper"
    >
      <div>
        <div style={menuStyles.topContainer as any} className="topContainer">
          <div style={{ marginTop: 30, marginBottom: 20 }}>
            <img style={menuStyles.logo} src="/images/logo.png" />
          </div>
        </div>
      </div>
      <div>
        <div
          style={menuStyles.contentContainer as any}
          className="contentContainer"
        >
          <Menu />
          <div style={menuStyles.content} className="content">
            {children}
          </div>
        </div>
      </div>
    </div>
  </MediaQuery>
);

export default large;
